import * as Dtos from "../dtos/Tmd.dtos";
import {  IFormFilter } from "../reducers/index";

export const
    LoadProjectItemTemplate: IProjectItemTemplateLoadActionCreator = (projectId) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATES_LOAD,
            projectId
        }
    },
    LoadProjectItemTemplateById: IProjectItemTemplateLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATES_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IProjectItemTemplateLoadSuccessActionCreator = (formData, formDataGrouped, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATES_LOAD_SUCCESS,
            formData,
            formDataGrouped,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IProjectItemTemplateLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATES_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveProjectItemTemplate: IProjectItemTemplateSaveActionCreator = (formData, collectionFormData) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATES_SAVE,
            formData,
            collectionFormData
        }
    },
    SaveSuccess: IProjectItemTemplateSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATES_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IProjectItemTemplateSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATES_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateProjectItemTemplate: IProjectItemTemplateCreateActionCreator = (projectId) => {

        return {
            type: ACTION_PROJECTITEMTEMPLATES_CREATE,
            projectId
        }
    },
    CreateSuccess: IProjectItemTemplateCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATES_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IProjectItemTemplateCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATES_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateProjectItemTemplate: IProjectItemTemplateValidateActionCreator = (formData, collectionFormData) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATES_VALIDATE,
            formData,
            collectionFormData
        }
    },
    ValidateSuccess: IProjectItemTemplateValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATES_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IProjectItemTemplateValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATES_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IProjectItemTemplateClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATES_CLEAR,
            propertiesToClear
        }
    },
    Filter: IProjectItemTemplateFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_PROJECTITEMTEMPLATES_FILTER,
            formFilter
        }
    };



export const
    ACTION_PROJECTITEMTEMPLATES_LOAD = "ACTION_PROJECTITEMTEMPLATES_LOAD",
    ACTION_PROJECTITEMTEMPLATES_LOAD_BY_ID = "ACTION_PROJECTITEMTEMPLATES_LOAD_BY_ID",
    ACTION_PROJECTITEMTEMPLATES_LOAD_SUCCESS = "ACTION_PROJECTITEMTEMPLATES_LOAD_SUCCESS",
    ACTION_PROJECTITEMTEMPLATES_LOAD_FAILURE = "ACTION_PROJECTITEMTEMPLATES_LOAD_FAILURE",

    ACTION_PROJECTITEMTEMPLATES_SAVE = "ACTION_PROJECTITEMTEMPLATES_SAVE",
    ACTION_PROJECTITEMTEMPLATES_SAVE_SUCCESS = "ACTION_PROJECTITEMTEMPLATES_SAVE_SUCCESS",
    ACTION_PROJECTITEMTEMPLATES_SAVE_FAILURE = "ACTION_PROJECTITEMTEMPLATES_SAVE_FAILURE",

    ACTION_PROJECTITEMTEMPLATES_CREATE = "ACTION_PROJECTITEMTEMPLATES_CREATE",
    ACTION_PROJECTITEMTEMPLATES_CREATE_SUCCESS = "ACTION_PROJECTITEMTEMPLATES_CREATE_SUCCESS",
    ACTION_PROJECTITEMTEMPLATES_CREATE_FAILURE = "ACTION_PROJECTITEMTEMPLATES_CREATE_FAILURE",

    ACTION_PROJECTITEMTEMPLATES_VALIDATE = "ACTION_PROJECTITEMTEMPLATES_VALIDATE",
    ACTION_PROJECTITEMTEMPLATES_VALIDATE_SUCCESS = "ACTION_PROJECTITEMTEMPLATES_VALIDATE_SUCCESS",
    ACTION_PROJECTITEMTEMPLATES_VALIDATE_FAILURE = "ACTION_PROJECTITEMTEMPLATES_VALIDATE_FAILURE",

    ACTION_PROJECTITEMTEMPLATES_CLEAR = "ACTION_PROJECTITEMTEMPLATES_CLEAR",

    ACTION_PROJECTITEMTEMPLATES_FILTER = "ACTION_PROJECTITEMTEMPLATES_FILTER";

export interface IProjectItemTemplateLoadAction {
    type: "ACTION_PROJECTITEMTEMPLATES_LOAD";
    projectId: number;
}

export interface IProjectItemTemplateLoadActionCreator {
    (projectId: number): IProjectItemTemplateLoadAction;
}

export interface IProjectItemTemplateLoadSuccessAction {
    type: "ACTION_PROJECTITEMTEMPLATES_LOAD_SUCCESS";
    formData: Dtos.ProjectItemTemplate | Dtos.ProjectItemTemplate[];
    formDataGrouped: Dtos.ProjectItemTemplateCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectItemTemplateLoadSuccessActionCreator {
    (
        formData: Dtos.ProjectItemTemplate | Dtos.ProjectItemTemplate[],
        formDataGrouped: Dtos.ProjectItemTemplateCategory[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IProjectItemTemplateLoadSuccessAction;
}

export interface IProjectItemTemplateLoadFailureAction {
    type: "ACTION_PROJECTITEMTEMPLATES_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectItemTemplateLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectItemTemplateLoadFailureAction;
}

export interface IProjectItemTemplateLoadByIdAction {
    type: "ACTION_PROJECTITEMTEMPLATES_LOAD_BY_ID";
    id: number;
}

export interface IProjectItemTemplateLoadByIdActionCreator {
    (id: number): IProjectItemTemplateLoadByIdAction;
}


export interface IProjectItemTemplateSaveAction {
    type: "ACTION_PROJECTITEMTEMPLATES_SAVE";
    formData: Dtos.ProjectItemTemplate;
    collectionFormData: Dtos.Collection;

}

export interface IProjectItemTemplateSaveActionCreator {
    (
        formData: Dtos.ProjectItemTemplate,
        collectionFormData: Dtos.Collection
    ): IProjectItemTemplateSaveAction;
}

export interface IProjectItemTemplateSaveSuccessAction {
    type: "ACTION_PROJECTITEMTEMPLATES_SAVE_SUCCESS";
    formData: Dtos.ProjectItemTemplate;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectItemTemplateSaveSuccessActionCreator {
    (
        formData: Dtos.ProjectItemTemplate,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IProjectItemTemplateSaveSuccessAction;
}

export interface IProjectItemTemplateSaveFailureAction {
    type: "ACTION_PROJECTITEMTEMPLATES_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectItemTemplateSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectItemTemplateSaveFailureAction;
}

export interface IProjectItemTemplateCreateAction {
    type: "ACTION_PROJECTITEMTEMPLATES_CREATE";
    projectId: number;
}

export interface IProjectItemTemplateCreateActionCreator {
    (projectId: number): IProjectItemTemplateCreateAction
}

export interface IProjectItemTemplateCreateSuccessAction {
    type: "ACTION_PROJECTITEMTEMPLATES_CREATE_SUCCESS";
    formData: Dtos.ProjectItemTemplate;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface IProjectItemTemplateCreateSuccessActionCreator {
    (
        formData: Dtos.ProjectItemTemplate,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IProjectItemTemplateCreateSuccessAction;
}

export interface IProjectItemTemplateCreateFailureAction {
    type: "ACTION_PROJECTITEMTEMPLATES_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectItemTemplateCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectItemTemplateCreateFailureAction;
}

export interface IProjectItemTemplateValidateAction {
    type: "ACTION_PROJECTITEMTEMPLATES_VALIDATE";
    formData: Dtos.ProjectItemTemplate;
    collectionFormData: Dtos.Collection;

}

export interface IProjectItemTemplateValidateActionCreator {
    (
        formData: Dtos.ProjectItemTemplate,
        collectionFormData: Dtos.Collection
    ): IProjectItemTemplateValidateAction;
}

export interface IProjectItemTemplateValidateSuccessAction {
    type: "ACTION_PROJECTITEMTEMPLATES_VALIDATE_SUCCESS";
    formData: Dtos.ProjectItemTemplate;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IProjectItemTemplateValidateSuccessActionCreator {
    (
        formData: Dtos.ProjectItemTemplate,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IProjectItemTemplateValidateSuccessAction;
}

export interface IProjectItemTemplateValidateFailureAction {
    type: "ACTION_PROJECTITEMTEMPLATES_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IProjectItemTemplateValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IProjectItemTemplateValidateFailureAction;
}

export interface IProjectItemTemplateClearAction {
    type: "ACTION_PROJECTITEMTEMPLATES_CLEAR";
    propertiesToClear?: string[];
}

export interface IProjectItemTemplateClearActionCreator {
    (propertiesToClear?: string[]): IProjectItemTemplateClearAction;
}

export interface IProjectItemTemplateFilterActionCreator {
    (formFilter: IFormFilter): IProjectItemTemplateFilterAction;
}

export interface IProjectItemTemplateFilterAction {
    type: "ACTION_PROJECTITEMTEMPLATES_FILTER";
    formFilter: IFormFilter;
}

export type ProjectItemTemplateAction =
    IProjectItemTemplateLoadAction |
    IProjectItemTemplateLoadByIdAction |
    IProjectItemTemplateLoadFailureAction |
    IProjectItemTemplateLoadSuccessAction |
    IProjectItemTemplateSaveAction |
    IProjectItemTemplateSaveSuccessAction |
    IProjectItemTemplateSaveFailureAction |
    IProjectItemTemplateCreateAction |
    IProjectItemTemplateCreateSuccessAction |
    IProjectItemTemplateCreateFailureAction |
    IProjectItemTemplateValidateAction |
    IProjectItemTemplateValidateSuccessAction |
    IProjectItemTemplateValidateFailureAction |
    IProjectItemTemplateClearAction |
    IProjectItemTemplateFilterAction;
